import type { ModValue } from './types.js';

export const blockModClassName = (blockName: string, modName: string, modValue: ModValue) => {
    if (!modValue && modValue !== 0) return;

    if (modValue === true) {
        return `${blockName}_${modName}`;
    }

    return `${blockName}_${modName}_${modValue}`;
};
